<template>
    <transition name="slide-fade">
        <div class="modal mx-auto" :class="{'open' : open}" v-if="open">
            <div class="modal-content px-5 py-24">
                <div class="bg-white w-full h-full rounded-40 p-4 border-b-8 border-a-black-080909">
                    <div class="font-SemiBold text-center text-20 pt-2.5 text-a-black-080909" v-html="title"></div>
                    <div class="pdpa-content font-Text text-16 my-5 text-a-gray-666666 overflow-scroll break-words" v-html="message"></div>
                    <button class="font-SemiBold text-16 text-a-black-080909 border border-a-black-080909 w-full rounded-40 pt-5 pb-4 font-SemiBold" @click="clickOk()">
                        {{btnOk}}
                    </button>
                    <div class="py-5">
                        <img class="mx-auto" src="../../../assets/Logo-Bzbs.svg"/>
                    </div>
                    <!-- <div class="font-SemiBold text-center text-16 text-a-black-080909 pt-9 pb-3" @click="clickCancel()">
                        {{btnCancel}}
                    </div> -->
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import { inject } from "vue";
// import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "PdpaContentModal",
    // mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    setup: function () {
        const { lbl, localeCode } = inject("LocaleStore")

        return {
            lbl,
            localeCode,
        }
    },
    data: function() {
        return {
            open: false,

            title: '',
            message: '',
            btnOk: '',
            btnCancel: '',
            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    watch: {
        '$route.path': function() {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.base_button.confirm;
            }
            if (Util.isEmptyStr(this.btnCancel)) {
                this.btnCancel = this.lbl.base_button.cancel;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel();
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    @import '../../../style/base.scss';
    .modal {
        max-width: 414px;
        max-height: 991px;
        @extend %modal;
        .modal-content {
            width: 100%;
            height: 100%;
            @include tablet {
                padding: 118px 142px;
            }
        }
        @include tablet {
            max-width: 834px;
            max-height: 1034px;
            margin: auto;
        }
    }
    .font-SemiBold {
        font-family: $ff-semi;
    }
    .font-Medium {
        font-family: $ff-Medium;
    }
    .font-Text {
        font-family: $ff-text;
    }
    .pdpa-content {
        height: calc(100% - 174px);
    }
</style>
